import { gt, valid } from 'semver';

export const greaterThan = (version1: string, version2: string): boolean => {
  const version1Valid = valid(version1);
  const version2Valid = valid(version2);

  if (version1Valid !== null && version2Valid === null) {
    return true;
  }

  if (version1Valid === null && version2Valid !== null) {
    return false;
  }

  if (version1Valid === null && version2Valid === null) {
    return false;
  }

  return gt(version1, version2);
};
